import {capitalize} from "@/helpers/capitalize";
import {useEffect} from "react";

const useFormSuccessMutation = ([api, endpoint] = [], callback, deps) => {
    const [_, {isSuccess, data, reset} = {}] = api?.[`use${capitalize(endpoint)}Mutation`]?.({
        fixedCacheKey: `${endpoint}.form`
    }) ?? []

    useEffect(() => {
        if (isSuccess && data) {
            callback(data)
            reset()
        }
    }, [isSuccess, data, ...deps]);
}

export default useFormSuccessMutation;
